/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _region = _interopRequireDefault(require("../../../../packages/region"));

var _join = _interopRequireDefault(require("../../../../packages/join"));

var _humanize = _interopRequireDefault(require("../../../../utils/humanize"));

var _ColumnResizer = _interopRequireDefault(require("../../Cell/ColumnResizer"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var emptyObject = Object.freeze ? Object.freeze({}) : {};
var BASE_CLASS_NAME = 'InovuaReactDataGrid__header-group__title';
var TOP_Z_INDEX = 10000;
var defaultProps = {
  isHeaderGroup: true
};
var propTypes = {
  columnResizeHandleWidth: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  group: _propTypes.default.shape({
    name: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
    className: _propTypes.default.string,
    style: _propTypes.default.object,
    headerClassName: _propTypes.default.string,
    headerStyle: _propTypes.default.object
  }),
  depth: _propTypes.default.number.isRequired,
  columns: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])).isRequired,
  children: _propTypes.default.node,
  extraChildrenProps: _propTypes.default.object,
  containsLastColumn: _propTypes.default.bool,
  lastInSection: _propTypes.default.bool,
  filterable: _propTypes.default.bool,
  onResizeMouseDown: _propTypes.default.func,
  onResizeTouchStart: _propTypes.default.func,
  parentGroups: _propTypes.default.array,
  showBorderLeft: _propTypes.default.bool,
  showBorderRight: _propTypes.default.bool,
  siblingCount: _propTypes.default.number,
  siblingIndex: _propTypes.default.number
};

var getHeader = function getHeader() {
  var group = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyObject;
  var header = group.header,
      name = group.name;

  if (header) {
    if (typeof header !== 'function') {
      return header;
    }

    return header(group);
  }

  return (0, _humanize.default)(name || '');
};

var HeaderGroup = function (_React$Component) {
  (0, _inherits2.default)(HeaderGroup, _React$Component);

  var _super = _createSuper(HeaderGroup);

  function HeaderGroup(_props) {
    var _this;

    (0, _classCallCheck2.default)(this, HeaderGroup);
    _this = _super.call(this, _props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "domRef", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setTop", function (top) {
      _this.setState({
        top: top
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setLeft", function (left) {
      _this.setState({
        left: left
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setRight", function (right) {
      _this.setState({
        right: right
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setHeight", function (height) {
      _this.setState({
        height: height
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setWidth", function (width) {
      _this.setState({
        width: width
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setDragging", function (dragging, callback) {
      var newState = {
        dragging: dragging
      };

      if (!dragging) {
        newState.top = 0;
        newState.left = 0;
        newState.width = 0;
        newState.height = 0;
      }

      _this.setState(newState, callback);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "prepareStyle", function () {
      var _assertThisInitialize = (0, _assertThisInitialized2.default)(_this),
          state = _assertThisInitialize.state,
          props = _assertThisInitialize.props;

      var style = props.style || {};
      var group = props.group;
      var headerProps = group.headerProps;

      if (props.group.style) {
        style = _objectSpread(_objectSpread({}, style), props.group.style);
      }

      if (headerProps && headerProps.style) {
        style = _objectSpread(_objectSpread({}, style), headerProps.style);
      }

      if (state.dragging) {
        style = Object.assign({}, style, {
          zIndex: TOP_Z_INDEX
        });

        if (_this.props.rtl) {
          style.right = state.right || 0;
        } else {
          style.left = state.left || 0;
        }

        style.top = state.top || 0;
        style.height = state.height || '';
        style.width = state.width || '';
        style.position = 'absolute';
        style.overflow = 'hidden';
      }

      return style;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getProxyRegion", function () {
      var node = _this.domRef ? _this.domRef.current : null;

      var region = _region.default.from(node);

      if (_this.props.filterable) {
        var filterWrapper = node.querySelector('.InovuaReactDataGrid__column-header__filter-wrapper');

        if (filterWrapper) {
          region.setHeight(region.getHeight() - filterWrapper.offsetHeight);
        }
      }

      return region;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderChild", function (child, index) {
      var extraProps = {
        parent: (0, _assertThisInitialized2.default)(_this),
        indexInHeaderGroup: index
      };
      var dragging = _this.props.dragging || _this.state.dragging;

      if (_this.props.extraChildrenProps) {
        Object.assign(extraProps, _this.props.extraChildrenProps);
      }

      if (dragging) {
        extraProps.dragging = dragging;
      }

      extraProps.key = index;
      return (0, _react.cloneElement)(child, extraProps);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onResizeMouseDown", function (event) {
      if (_this.props.onResizeMouseDown) {
        event.stopPropagation();

        _this.props.onResizeMouseDown(_this.props, (0, _assertThisInitialized2.default)(_this), event);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onResizeTouchStart", function (event) {
      if (_this.props.onResizeTouchStart) {
        event.stopPropagation();

        _this.props.onResizeTouchStart(_this.props, (0, _assertThisInitialized2.default)(_this), event);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onMouseDown", function (event) {
      if (_this.props.onMouseDown) {
        _this.props.onMouseDown(event, _this.props, (0, _assertThisInitialized2.default)(_this));
      }
    });
    _this.state = {
      dragging: false
    };
    _this.domRef = _react.default.createRef();
    return _this;
  }

  (0, _createClass2.default)(HeaderGroup, [{
    key: "render",
    value: function render() {
      var _style;

      var props = this.props;
      var showBorderLeft = props.showBorderLeft,
          showBorderRight = props.showBorderRight,
          resizable = props.resizable,
          children = props.children,
          group = props.group,
          dragging = props.dragging,
          depth = props.depth,
          columnResizeHandleWidth = props.columnResizeHandleWidth,
          containsLastColumn = props.containsLastColumn,
          firstInSection = props.firstInSection,
          lastInSection = props.lastInSection,
          adjustResizer = props.adjustResizer,
          locked = props.locked,
          rtl = props.rtl,
          resizeProxyStyle = props.resizeProxyStyle;
      var style = this.prepareStyle();
      var resizerRight = containsLastColumn || adjustResizer || lastInSection ? 0 : -props.columnResizeHandleWidth / 2;
      var header = getHeader(group);

      var _ref = group || emptyObject,
          headerAlign = _ref.headerAlign;

      var className = (0, _join.default)(BASE_CLASS_NAME, firstInSection && 'InovuaReactDataGrid__header-group__title--first-in-section', "InovuaReactDataGrid__header-group__title--depth-".concat(depth), group.headerClassName, "InovuaReactDataGrid__header-group__title--direction-".concat(rtl ? 'rtl' : 'ltr'), showBorderLeft && "InovuaReactDataGrid__header-group__title--show-border-".concat(rtl ? 'right' : 'left'), showBorderRight && "InovuaReactDataGrid__header-group__title--show-border-".concat(rtl ? 'left' : 'right'), locked && "InovuaReactDataGrid__header-group__title--locked-".concat(locked), dragging && "InovuaReactDataGrid__header-group__title--dragging", containsLastColumn && 'InovuaReactDataGrid__header-group__title--last', !header ? 'InovuaReactDataGrid__header-group__title--empty' : null, "".concat(BASE_CLASS_NAME, "--align-").concat(headerAlign || 'start'));
      var groupHeader = !header && !depth ? null : _react.default.createElement("div", {
        style: group.headerStyle,
        className: className
      }, header || "\xA0");
      var resizeHandleStyle;

      if (resizable) {
        resizeHandleStyle = {
          width: columnResizeHandleWidth
        };

        if (resizeProxyStyle) {
          resizeHandleStyle = Object.assign({}, resizeProxyStyle, resizeHandleStyle);
        }
      }

      var resizer = resizable ? _react.default.createElement(_ColumnResizer.default, {
        className: "InovuaReactDataGrid__header-group-resizer",
        onMouseDown: this.onResizeMouseDown,
        onTouchStart: this.onResizeTouchStart,
        style: (_style = {
          width: columnResizeHandleWidth
        }, (0, _defineProperty2.default)(_style, rtl ? 'left' : 'right', resizerRight), (0, _defineProperty2.default)(_style, rtl ? 'right' : 'left', 'unset'), (0, _defineProperty2.default)(_style, "zIndex", depth * 10000 + (100 - this.props.firstIndex || 0)), _style),
        resizeHandleStyle: resizeHandleStyle,
        resizeHandleClassName: "InovuaReactDataGrid__header-group-resize-handle"
      }) : null;
      var headerProps = group.headerProps;
      return _react.default.createElement("div", {
        onMouseDown: this.onMouseDown,
        style: style,
        ref: this.domRef,
        className: (0, _join.default)(props.className, 'InovuaReactDataGrid__header-group', group.className, props.inTransition && 'InovuaReactDataGrid__header-group--transition', this.state.dragging && 'InovuaReactDataGrid__header-group--dragging', headerProps && headerProps.className ? headerProps.className : '')
      }, resizer, groupHeader, _react.default.createElement("div", {
        className: "InovuaReactDataGrid__header-group-cells"
      }, children.map(this.renderChild)));
    }
  }]);
  return HeaderGroup;
}(_react.default.Component);

exports.default = HeaderGroup;
(0, _defineProperty2.default)(HeaderGroup, "defaultProps", defaultProps);
(0, _defineProperty2.default)(HeaderGroup, "propTypes", propTypes);
